
import CheckoutB2B from '~/pages/_lang/checkout/shipping/_tempId.vue'
export default CheckoutB2B
